import { render, staticRenderFns } from "./SkinSetItemDialog.vue?vue&type=template&id=7e589c69&scoped=true&"
import script from "./SkinSetItemDialog.vue?vue&type=script&lang=ts&"
export * from "./SkinSetItemDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e589c69",
  null
  
)

export default component.exports